"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Avatar = ({ title, size = 20, src, ...props }) => {
    const { sx = [], bgcolor, ...otherProps } = props;
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { bgcolor: bgcolor ?? (({ palette }) => palette.blue[70]), sx: [
            {
                width: size,
                height: size,
                display: "flex",
                ...(!src && {
                    alignItems: "center",
                    justifyContent: "center",
                }),
                borderRadius: "50%",
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], ...otherProps, children: src ? ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", src: src, sx: {
                height: "100%",
                width: "100%",
                objectFit: "cover",
                borderRadius: "50%",
            } })) : ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "span", sx: {
                color: ({ palette }) => palette.common.white,
                fontSize: size / 2,
                fontWeight: 700,
                lineHeight: 1,
            }, children: title ? title.charAt(0).toUpperCase() : undefined })) }));
};
exports.Avatar = Avatar;
